export const FileUtils = {
    savePdfToDisk: function (response) {
        const blob = new Blob([response.data], {type: "application/pdf"});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
        let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
        link.download = `${filename}.${extension}`.replaceAll("\"", "");
        link.click();
        URL.revokeObjectURL(link.href);
    },
    saveExcelToDisk: function (response) {
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
        let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
        link.download = `${filename}.${extension}`.replaceAll("\"", "");
        link.click();
        URL.revokeObjectURL(link.href);
    }
}
